import { featuresEnum } from '@/utils/featureUtils'

const TheContainer = () => import('@/containers/TheContainer')
const ManageBalance = () => import('./pages/ManageBalance')
const ManageBalanceDistributed = () => import('./pages/ManageBalanceDistributed')
const ManageBalanceDistributedWithOrigin = () => import('./pages/ManageBalanceDistributedWithOrigin')
const ManagePlans = () => import('./pages/ManagePlans')
const Modal = () => import('./pages/Modal')

const backOfficeRoutes = [
  {
    path: 'backOffice',
    component: TheContainer,
    children: [
      // {
      //   path: 'backOffice-manage-balance/',
      //   name: 'backOffice-manage-balance',
      //   component: ManageBalance,
      //   meta: { requiresAuth: true },
      // },
      {
        path: 'backOffice-manage-balance',
        name: 'manage-balance-indirect-distribution',
        component: ManageBalanceDistributed,
        meta: { requiresAuth: true },
      },
      {
        path: 'backOffice-manage-balance/:targetOrganizationId',
        name: 'manage-balance-distributed',
        component: ManageBalanceDistributedWithOrigin,
        meta: { requiresAuth: true },
      },
      {
        path: 'backOffice-manage-plans',
        name: 'manage-balance-plans',
        component: ManagePlans,
        meta: { requiresAuth: true, feature_flag: featuresEnum.SUBSCRIPTION_PLANS  },
      },
      {
        path: 'backOffice-manage-plans2',
        name: 'manage-balance-plans2',
        component: Modal,
        meta: { requiresAuth: true },
      },
    ],
  },
]

export default backOfficeRoutes
